/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
"use strict";

const Hook = require("./Hook");
const HookCodeFactory = require("./HookCodeFactory");
class SyncBailHookCodeFactory extends HookCodeFactory {
  content(_ref) {
    let onError = _ref.onError,
      onResult = _ref.onResult,
      resultReturns = _ref.resultReturns,
      onDone = _ref.onDone,
      rethrowIfPossible = _ref.rethrowIfPossible;
    return this.callTapsSeries({
      onError: (i, err) => onError(err),
      onResult: (i, result, next) => `if(${result} !== undefined) {\n${onResult(result)};\n} else {\n${next()}}\n`,
      resultReturns,
      onDone,
      rethrowIfPossible
    });
  }
}
const factory = new SyncBailHookCodeFactory();
class SyncBailHook extends Hook {
  tapAsync() {
    throw new Error("tapAsync is not supported on a SyncBailHook");
  }
  tapPromise() {
    throw new Error("tapPromise is not supported on a SyncBailHook");
  }
  compile(options) {
    factory.setup(this, options);
    return factory.create(options);
  }
}
module.exports = SyncBailHook;